//@flow
import { branch, renderComponent } from 'recompose'
import Loading from '../ui/views/loading'

type PropsPredicateFunction = (props: Object) => boolean

const withLoadingUntilFn = (predicateFn: PropsPredicateFunction) =>
  branch(props => predicateFn(props), renderComponent(Loading))

export default withLoadingUntilFn



// WEBPACK FOOTER //
// ./src/core/withLoadingUntilFn.js